import { ref, watch } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export function useCurrentRoute(routeNames, params = {}) {
  const { url } = usePage()

  const currentUrlMatchesRouteNames = (routeNamesToCheck) => {
    return []
      .concat(routeNamesToCheck)
      .filter((routeNameToCheck) => routeNameToCheck)
      .some((routeNameToCheck) => route().current(routeNameToCheck, params))
  }

  const isCurrentForRouteNames = ref(currentUrlMatchesRouteNames(routeNames))

  watch(url, () => {
    isCurrentForRouteNames.value = currentUrlMatchesRouteNames(routeNames)
  })

  return {
    currentUrlMatchesRouteNames,
    isCurrentForRouteNames
  }
}
